import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForgotPasswordContext } from '../ForgotPasswordContext';
import { CheckCircleIcon } from '../../../assets/icons';

function Step3() {
  const navigate = useNavigate();
  const { isPasswordChanged } = useForgotPasswordContext();

  useEffect(() => {
    if (isPasswordChanged) {
      setTimeout(() => navigate('/login'), 2000);
    }
  }, [isPasswordChanged]);

  return (
    <div className='px-6 py-9 text-center sm:px-12 sm:py-11'>
      <div className='mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#DCFCE7] text-[#16A34A] ring-8 ring-[#F0FDF4]'>
        <CheckCircleIcon className='h-10 w-10 text-[#16A34A]' />
      </div>
      <div>
        <h3 className='font-serif text-2xl font-normal leading-tight text-[#0B1929]'>Password changed</h3>
        <p className='mt-2 text-sm leading-6 text-[#7A9AB0]'>Your password has been updated. Redirecting you to sign in.</p>
      </div>
      <div className='mt-7 space-y-4'>
        <p className='text-center text-sm leading-6 text-[#7A9AB0]'>You will be automatically redirected to the login page.</p>
        <a
          href='/login'
          className='inline-flex h-12 w-full items-center justify-center rounded-full bg-[#0B1929] px-7 text-sm font-semibold text-white transition hover:bg-[#0F2540]'
        >
          Sign in
        </a>
      </div>
    </div>
  );
}

export default Step3;
